import { defineComponent, ref, onMounted, watch } from 'vue';
import { watchDebounced } from '@vueuse/core'

import axios from 'axios';

export default defineComponent({
    setup(props, ctx) {
        let apiHost = '';
        if (process.env.NODE_ENV === 'development') {
            apiHost = process.env.MIX_API_HOST_DEV;
        } else {
            apiHost = process.env.MIX_API_HOST_PROD;
        }

        const loading = ref(false);
        
        const zipCode = ref('');
        function getZipCodeFromField() {
            const zipField = document.getElementById('zip-code-field');
            const zipValue = zipField.getAttribute("data-value-saved");
            
            if(zipField && zipValue) {
                return zipValue
            }
        }

        const city = ref('');
        function getCityName(zipCode) {
            loading.value = true;
            axios.get(apiHost + "/api/v1/zip", {
                params: {
                    zip: zipCode
                }
            }).then(response => {
                if(response.data.city != undefined && response.data.city != "") {
                    city.value = response.data.city;
                } else {
                    city.value = "Ugyldig postnummer!";
                }
                loading.value = false;
            }).catch(error => {
                console.log(error);
            });
        }

        watchDebounced(zipCode, (newVal) => {
            if(newVal.length != 4) {
                city.value = "Ugyldig postnummer!";
            } else {
                city.value = getCityName(newVal);
            }

        },{debounce: 500 });

        onMounted(() => {
            zipCode.value = getZipCodeFromField();
            city.value = getCityName(zipCode.value);
        });

        return {
            zipCode,
            city,
            loadingCity: loading,
        }
    },
    compilerOptions: {
        delimiters: ["[[", "]]"]
      }
});